<script setup lang="ts">
import CommonDatePicker from "@/components/common/CommonDatepicker.vue";
import CommonDropdown from "@/components/common/CommonDropdown.vue";
import { ref } from "vue";

const singleDate = ref<Date | null>(null);
const rangeStart = ref<Date | null>(null);
const rangeEnd = ref<Date | null>(null);

function onSingleUpdate(
  _start?: Date | null,
  _end?: Date | null,
  date?: Date | null
) {
  singleDate.value = date ?? null;
}

function onRangeUpdate(start?: Date | null, end?: Date | null) {
  rangeStart.value = start ?? null;
  rangeEnd.value = end ?? null;
}

const items = [
  { value: "1", name: "Item 1" },
  { value: "2", name: "Item 2" },
  { value: "3", name: "Item 3" },
];

const selected = ref<string | number>("");
</script>

<template>
  <div class="v-home">
    <!-- Одиночная дата -->
    <CommonDatePicker
      mode="single"
      :clearable="true"
      placement="bottom"
      @update="onSingleUpdate"
    />
    <p>Выбрана: {{ singleDate?.toLocaleDateString() || "не выбрано" }}</p>

    <!-- Диапазон -->
    <CommonDatePicker
      mode="range"
      :clearable="true"
      placement="bottom"
      @update="onRangeUpdate"
    />

    <!-- Двусторонний с ограничением -->
    <CommonDatePicker
      mode="range"
      :isTwoSided="true"
      :clearable="true"
      :maxDaysRange="30"
      placement="bottom"
      @update="onRangeUpdate"
    />

    <!-- С дефолтным диапазоном -->
    <CommonDatePicker
      mode="range"
      :clearable="true"
      :defaultRange="{
        fromDate: new Date(2026, 3, 1),
        toDate: new Date(2026, 3, 14),
      }"
      @update="onRangeUpdate"
    />

    <CommonDropdown
      v-model="selected"
      :items="items"
      label="Выберите"
      position="bottom"
    />
  </div>
</template>

<style scoped lang="scss">
.v-home {
  padding: var(--base-space-24);
  display: flex;
  flex-direction: column;
  gap: 80px;
  align-items: flex-start;
}
</style>
